import React, { useRef } from 'react'

import { useSubmit } from '@cvg/react-hooks'

import { getFilenameDate } from '@utils/dayjs'

import DownArrow from '@components/Icons/DownArrow'

import styles from './styles.module.css'

const DownloadButton = ({ entry: { media, tags, createdAt } }) => {
  const linkRef = useRef(null)

  const downloadMedia = async () => {
    const response = await fetch(media.file.url)
    const blobUrl = await response.blob().then(URL.createObjectURL)

    if (linkRef.current) {
      linkRef.current.href = blobUrl
      linkRef.current.download = `${tags.fcpId}-${getFilenameDate(createdAt)}`
      linkRef.current.click()
    }

    URL.revokeObjectURL(blobUrl)
  }

  const { submit, error, isSubmitting } = useSubmit(downloadMedia)

  return (
    <div className={styles.download}>
      <button onClick={submit} disabled={isSubmitting}>
        <DownArrow />
        Download Media
      </button>

      {error && <p>Could not download media. Please try again later.</p>}

      <a ref={linkRef} />
    </div>
  )
}

export default DownloadButton
